// import { collection, query, where, getDocs } from "firebase/firestore";
// import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
// import { db, auth } from "../firebaseConfig";

// export const generatePDF = async () => {
//     try {
//         const user = auth.currentUser;
//         if (!user) {
//             alert("Please log in!");
//             console.log("No user found.");
//             return;
//         }

//         console.log("Logged-in User UID:", user.uid);

//         // Query Firestore collection where "userId" matches "user.uid"
//         const vendorQuery = query(collection(db, "vendors"), where("userId", "==", user.uid));
//         const querySnapshot = await getDocs(vendorQuery);

//         if (querySnapshot.empty) {
//             console.log("No vendor document found for user UID:", user.uid);
//             return alert("No vendor data found! Check Firestore document.");
//         }

//         // Get the first matching document
//         const docSnap = querySnapshot.docs[0];
//         const data = docSnap.data();

//         console.log("Vendor data found:", data);

//         // Proceed with PDF generation
//         const pdfDoc = await PDFDocument.create();
//         let page = pdfDoc.addPage([595, 842]); // A4 size (width, height)
//         const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//         const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//         const textColor = rgb(0, 0, 0);

//         // Function to draw text at specified position
//         const drawText = (text, x, y, size = 12, isBold = false) => {
//             page.drawText(text, { x, y, size, font: isBold ? boldFont : font, color: textColor });
//         };

//         // Function to draw center-aligned text
//         const drawCenteredText = (text, y, size = 12, isBold = false) => {
//             const textWidth = (isBold ? boldFont : font).widthOfTextAtSize(text, size);
//             const x = (595 - textWidth) / 2; // Center alignment
//             page.drawText(text, { x, y, size, font: isBold ? boldFont : font, color: textColor });
//         };

//         let startY = 800; // Start position

//         // Title
//         drawCenteredText("Non-disclosure Agreement", startY, 14, true);

//         // Party details
//         startY -= 40;
//         drawText("The M/s Relax Exim LLP, Flat B-301, 3rd Floor Gokul Heights CHSL,", 50, startY);
//         drawText("Opp. Cambridge School, Thakur Complex, Kandivali East, Mumbai,", 50, startY - 15);
//         drawText("Maharashtra - 400101 as 'Receiving Party'", 50, startY - 30);

//         drawCenteredText("And", startY - 50);

//         drawText(`M/s ${data.name}, having its registered office at ${data.address},`, 50, startY - 70);
//         drawText("as 'Disclosing Party'.", 50, startY - 90);

//         startY -= 120;

//         // NDA Content
//         const ndaText = [
//             "1. WHEREAS, it is anticipated that the receiving party may get access to Information/data with respect ",
//             "to 'Disclosing Party' for the purpose of Imaging Extraction, Forensic Analysis and Data analysis.",

//             "2. All Information/data disclosed pursuant to this Declaration:",
//             "   a. shall be used exclusively for the Purpose of this Declaration, and the receiving party shall be",
//             "       permitted to use Information/data disclosed only for such sole Purpose and for no other purpose, ",
//             "       unless otherwise expressly agreed to in writing by disclosing party;",
//             "   b. shall not be distributed, disclosed, or disseminated in any way or form by the receiving party to anyone",
//             "      except parties who have the reasonable need to know the Information/data and who are bound to confidentiality",
//             "      by their Employment agreement;",
//             "   c. shall not be disclosed to any other third party without the prior written approval from disclosing party;",
//             "   d. Shall not be used for personal purpose or for the benefit of anyone other than the disclosing party.",

//             "3. Receiving party agrees that it shall treat Information/data disclosed under this Declaration as strictly",
//             "   confidential perpetually.",
//             "4. All Information/data disclosed pursuant to this Declaration shall either be returned to disclosing party or be ",
//             "   destroyed immediately upon cessation of engagement.",
//             "5. In the event of a breach or threatened breach of this Declaration by or any one acting on behalf of the ",
//             "   Receiving party, without prejudice to other rights and remedies which disclosing party may have in ",
//             "   this regard,disclosing party shall be entitled to seek any equitable relief, specific performance or ",
//             "   any such applicable relief from any court of competent jurisdiction.",
//             "6. This Declaration shall be governed by laws of India.",
//             "7. If any term, clause or provision of this Declaration shall be judged to be invalid for any reason whatsoever, ",
//             "   such invalidity shall not affect the validity or operation of any other term, clause or provision of this Declaration ",
//             "   and such invalid term clause or provision shall be deemed to have been deleted from this Declaration.",
//             "8. The provisions of this Declaration may not be modified, amended, nor waived, except by a written instrument ",
//             "    duly executed by the Parties here to. The requirement of written form can only be waived in writing."
//         ];

//         for (const line of ndaText) {
//             drawText(line, 50, startY, 10);
//             startY -= 15;
//             if (startY <= 50) {
//                 startY = 800;
//                 page = pdfDoc.addPage([595, 842]); // Add new page if needed
//             }
//         }

//         // Signature section
//         startY -= 30;
//         drawText("I agree to have read and abide by the above Declaration.", 50, startY);

//         startY -= 50;
//         drawText("For Relax Exim LLP", 50, startY);
//         drawText("Authorized Signatory", 50, startY - 20);
//         drawText("Date: ____________", 50, startY - 40);

//         drawText("Accepted", 350, startY);
//         drawText("For and on behalf of", 350, startY - 15);
//         drawText("The Service Receiver", 350, startY - 30);
//         drawText(`${data.AuthorizedSignatory}`, 350, startY - 45);
//         drawText(`${data.name}`, 350, startY - 60);
//         drawText("Date: ____________", 350, startY - 80);

//         // Save and download the filled NDA
//         const pdfBytes = await pdfDoc.save();
//         const blob = new Blob([pdfBytes], { type: "application/pdf" });
//         const link = document.createElement("a");
//         link.href = URL.createObjectURL(blob);
//         link.download = "NDA_Document.pdf";
//         link.click();
//     } catch (error) {
//         console.error("Error generating PDF:", error);
//     }
// };
    

import { collection, query, where, getDocs } from "firebase/firestore";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { db, auth } from "../firebaseConfig";

export const generatePDF = async () => {
    try {
        const user = auth.currentUser;
        if (!user) {
            alert("Please log in!");
            console.log("No user found.");
            return;
        }

        console.log("Logged-in User UID:", user.uid);

        // Query Firestore collection where "userId" matches "user.uid"
        const vendorQuery = query(collection(db, "vendors"), where("userId", "==", user.uid));
        const querySnapshot = await getDocs(vendorQuery);

        if (querySnapshot.empty) {
            console.log("No vendor document found for user UID:", user.uid);
            return alert("No vendor data found! Check Firestore document.");
        }

        // Get the first matching document
        const docSnap = querySnapshot.docs[0];
        const data = docSnap.data();

        console.log("Vendor data found:", data);

        // Proceed with PDF generation
        const pdfDoc = await PDFDocument.create();
        let page = pdfDoc.addPage([595, 842]); // A4 size (width, height)
        const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
        const textColor = rgb(0, 0, 0);

        // Function to draw text at specified position (all text bold)
        const drawText = (text, x, y, size = 12) => {
            page.drawText(text, { x, y, size, font: boldFont, color: textColor });
        };

        // Function to draw center-aligned text (all text bold)
        const drawCenteredText = (text, y, size = 12) => {
            const textWidth = boldFont.widthOfTextAtSize(text, size);
            const x = (595 - textWidth) / 2; // Center alignment
            page.drawText(text, { x, y, size, font: boldFont, color: textColor });
        };

        let startY = 800; // Start position

        // Title
        drawCenteredText("Non-disclosure Agreement", startY, 14);

        // Party details (centered)
        startY -= 40;
        drawCenteredText("The M/s Relax Exim LLP,", startY);
        drawCenteredText("Flat B-301, 3rd Floor Gokul Heights CHSL,", startY - 15);
        drawCenteredText("Opp. Cambridge School, Thakur Complex,", startY - 30);
        drawCenteredText("Kandivali East, Mumbai, Maharashtra - 400101", startY - 45);
        drawCenteredText("as 'Receiving Party'", startY - 60);

        drawCenteredText("And", startY - 90);

        drawCenteredText(`M/s ${data.name},`, startY - 120);
        drawCenteredText(`having its registered office at ${data.address},`, startY - 135);
        drawCenteredText("as 'Disclosing Party'.", startY - 150);

        startY -= 180;

        // NDA Content (bold)
        const ndaText = [
            "1. WHEREAS, it is anticipated that the receiving party may get access to Information/data with respect",
            "to 'Disclosing Party' for the purpose of Imaging Extraction, Forensic Analysis and Data analysis.",

            "2. All Information/data disclosed pursuant to this Declaration:",
            "   a. shall be used exclusively for the Purpose of this Declaration, and the receiving party shall be",
            "       permitted to use Information/data disclosed only for such sole Purpose and for no other purpose,",
            "       unless otherwise expressly agreed to in writing by disclosing party;",
            "   b. shall not be distributed, disclosed, or disseminated in any way or form by the receiving party to anyone",
            "      except parties who have the reasonable need to know the Information/data and who are bound to ",
            "      confidentiality by their Employment agreement;",
            "   c. shall not be disclosed to any other third party without the prior written approval from disclosing party;",
            "   d. Shall not be used for personal purpose or for the benefit of anyone other than the disclosing party.",

            "3. Receiving party agrees that it shall treat Information/data disclosed under this Declaration as strictly",
            "   confidential perpetually.",
            "4. All Information/data disclosed pursuant to this Declaration shall either be returned to disclosing party or be",
            "   destroyed immediately upon cessation of engagement.",
            "5. In the event of a breach or threatened breach of this Declaration by or any one acting on behalf of the",
            "   Receiving party, without prejudice to other rights and remedies which disclosing party may have in",
            "   this regard, disclosing party shall be entitled to seek any equitable relief, specific performance or",
            "   any such applicable relief from any court of competent jurisdiction.",
            "6. This Declaration shall be governed by laws of India.",
            "7. If any term, clause or provision of this Declaration shall be judged to be invalid for any reason whatsoever,",
            "   such invalidity shall not affect the validity or operation of any other term, clause or provision of this ",
            "   Declaration and such invalid term clause or provision shall be deemed to have been deleted from this ",
            "   Declaration.",
            "8. The provisions of this Declaration may not be modified, amended, nor waived, except by a ",
            "   written instrument duly executed by the Parties hereto. The requirement of written form ",
            "   can only be waived in writing."
        ];

        for (const line of ndaText) {
            drawText(line, 50, startY, 10);
            startY -= 15;
            if (startY <= 50) {
                startY = 800;
                page = pdfDoc.addPage([595, 842]); // Add new page if needed
            }
        }

        // Signature section (bold)
        startY -= 30;
        drawText("I agree to have read and abide by the above Declaration.", 50, startY);

        startY -= 50;
        drawText("For Relax Exim LLP", 50, startY);
        drawText("Authorized Signatory", 50, startY - 20);
        drawText("Date: ____________", 50, startY - 40);

        drawText("Accepted", 350, startY);
        drawText("For and on behalf of", 350, startY - 15);
        drawText("The Service Receiver", 350, startY - 30);
        drawText(`${data.AuthorizedSignatory}`, 350, startY - 45);
        drawText(`${data.name}`, 350, startY - 60);
        drawText("Date: ____________", 350, startY - 80);

        // Save and download the filled NDA
        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "NDA_Document.pdf";
        link.click();
    } catch (error) {
        console.error("Error generating PDF:", error);
    }
};
